// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","page":"_2do33oZ7 mx-auto","header":"_31gLNlZJ","body":"_2kApYIyw","row":"_27tZRfKk clearfix"};